import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import Link from "next/link";
import React from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function DineWithDevopsDelhi2025({ props }) {
    const { t } = useTranslation('common');
    return(
        <>
            <Layout isHomePage={false} pageTitle={"Join Middleware at Sundown with DevOps 2025"}
                    ogImage={"/images/events/sundown-with-devops-2025.webp"}
                    uri={"/events/sundown-with-devops-2025/"}
                    metaTitle={"Join Middleware at Sundown with DevOps 2025"}
                    metaDesc={"Meet Middleware at Sundown with DevOps 2025 (Nov 28, Mumbai) to see how our observability platform reduces downtime and boosts productivity."}
                    metaRobotsNoindex={"index"}
                    metaRobotsNofollow={"follow"}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={"/events/"} className={"back-to-blog"}>Back to Event List</Link>
                                        <div className={'d-flex aws-mw'}>
                                        </div>
                                        <div className={'inner-hero'}>
                                            <h1>Join <span>Middleware</span> at <span>Sundown With DevOps</span> 2025!</h1>
                                            <p><b>Date: </b>November 28, 2025</p>
                                            <p><b>Venue: </b> Razzberry Rhinos, Juhu Hotel, Mumbai</p>
                                        </div>
                                    </div>
                                    <div className={'right-block closed'}>
                                        <img
                                            src={'/images/events/sundown-with-devops-2025.webp'} alt={'Join Middleware at Sundown with DevOps 2025'} width={"100%"} height={"100%"}/>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                <div className={'left-block sm-width'}>
                                    <p>Connect with our team at Sundown with Devops to discover how Middleware streamlines cloud observability, helping you resolve issues faster and enhance operational efficiency.</p>
                                    <h4>Meet Our Team</h4>
                                    <img src={"/images/events/middleware-team-india.png"} alt={"Middleware Team"}
                                         width={100} height={100}/>

                                    <ul>
                                        <li><Link href={"https://www.linkedin.com/in/sawaramsuthar/"}
                                                  target={"_blank"}>Sam Suthar</Link>, Founding Director, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/vivektilva/"} target={"_blank"}>Vivek
                                            Tilva</Link>, Product Manager, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/bhogayatakb/"} target={"_blank"}>Keval
                                            Bhogayata </Link>, Senior Staff Engineer, Middleware
                                        </li>
                                        <li><Link href={"https://www.linkedin.com/in/neelcshah/"}
                                                  target={"_blank"}>Neel Shah</Link>, Developer Advocate, Middleware
                                        </li>
                                    </ul>

                                    <h4>What’s Middleware All About?</h4>
                                    <p>Middleware is a <b>full-stack cloud observability platform</b> that empowers teams to
                                        optimize cloud operations, reduce downtime, and boost productivity with 100%
                                        ingestion control.
                                    </p>

                                    <h4>What does that mean for your business?</h4>
                                    <p><b>Upto 10X</b> reduction in <b>observability costs</b></p>
                                    <p><b>Upto 75%</b> improvement in <b>operational efficiency</b></p>
                                    <p><b>Upto 20%</b> faster <b>time to resolution (MTTR)</b></p>
                                    <p><b>Upto 25%</b> improved <b>developer productivity</b></p>

                                    <h4>Middleware’s Observability Suite Includes: </h4>

                                    <ul>
                                        <li><b>Infrastructure Monitoring:</b> Monitor and optimize infrastructure in
                                            real-time for peak efficiency.
                                        </li>
                                        <li><b>Log Monitoring:</b> Unify log data across your tech stack to quickly
                                            identify and fix issues.
                                        </li>
                                        <li><b>APM:</b> Track app performance, identify bottlenecks and fix issues in
                                            real time.
                                        </li>
                                        <li><b>LLM Observability:</b> Monitor, troubleshoot, and optimize LLM
                                            applications in real time.
                                        </li>
                                        <li><b>Database Monitoring:</b> Visualize and track database metrics in real
                                            time for optimal performance.
                                        </li>
                                        <li><b>Synthetic Monitoring:</b> Simulate your app to spot and fix issues before
                                            they affect customers.
                                        </li>
                                        <li><b>Serverless Monitoring:</b> Get full visibility and control over
                                            serverless apps for optimal performance.
                                        </li>
                                        <li><b>Container Monitoring:</b> Get real-time visibility into containerized
                                            apps with data and analytics.
                                        </li>
                                        <li><b>Real User Monitoring:</b> Analyze user journeys on the web and mobile to
                                            optimize performance and experience.
                                        </li>
                                    </ul>

                                    <h4>Get Hands-on with Middleware:</h4>

                                    <p>Wondering how Middleware can help you, register here for a <Link
                                        href={"/demo-request/"}>demo</Link> to see Middleware in action!</p>

                                    <h4>Swag Alert!</h4>
                                    <img src={"/images/events/middleware-swag.jpg"} alt={"Middleware Swag"} width={100} height={100}/>
                                    <p>Visit our booth to grab exclusive Middleware swag!</p>

                                    <h4>Missed us at Sundown with Devops?</h4>

                                    <p>No biggie! Schedule a <Link href={"https://middleware.cal.com/sam/middleware?user=sam"} target={"_blank"}>meeting</Link> to boost your cloud
                                        observability, and follow our <Link
                                            href={"https://middleware.io/blog/"}>blog </Link> for product updates and
                                        expert insights. </p>
                                </div>


                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
const translations = await serverSideTranslations(
        ctx?.locale ?? "en",
        ["common", "header", "footer"],
        nextI18NextConfig,
    );
    return {
        props: {
            ...translations,
            pageTitle: "Join Middleware at Sundown with DevOps 2025",
            description: "Meet Middleware at Sundown with DevOps 2025 (Nov 28, Mumbai) to see how our observability platform reduces downtime and boosts productivity.",
            ogImage: "/images/events/sundown-with-devops-2025.webp",
            uri: "/events/sundown-with-devops-2025/",
            metaTitle: "Join Middleware at Sundown with DevOps 2025",
            metaDesc: "Meet Middleware at Sundown with DevOps 2025 (Nov 28, Mumbai) to see how our observability platform reduces downtime and boosts productivity.",
            metaRobotsNoindex: "index",
            metaRobotsNofollow: "follow",
        },
        // revalidate: 10,
    }
}